<template>
  <div>
    <!-- sync logs  -->
    <b-modal
      scrollable
      :id="'syncLogsModal' + integrationData.id"
      size="lg"
      hide-header
      hide-footer
      no-close-on-esc
      @hide="$bvModal.hide('syncLogsModal' + integrationData.id)"
    >
      <div class="modal-height">
        <slot name="modal-header">
          <div class="flex-row">
            <h5 class="modal-title" style="color: #000000">
              <slot name="modal-title" class="">
                <span class=""> {{$t('integrations.syncLogs')}} </span>
              </slot>
            </h5>
            <div class="header-close-style d-flex align-items-center">
              <!-- <button
                  type="button"
                  class="header-close"
                  aria-label="headerCloseLabel"
                  @click="$bvModal.hide('syncLogsModal')"
                >
                  <span aria-hidden="true">&times;</span>
                </button> -->
              <div class="closing-design">
                <svg
                  @click="$bvModal.hide('syncLogsModal' + integrationData.id)"
                  style="cursor: pointer"
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
                    fill="#F46A6A"
                  />
                </svg>
              </div>
            </div>
          </div>
        </slot>
        <div class="table-style">
          <DxDataGrid
            :data-source="getSyncLogs"
            :remote-operations="false"
            :showBorders="false"
            :columnAutoWidth="true"
            :allowColumnReordering="false"
            :allowColumnResizing="true"
            :rowAlternationEnabled="true"
            :showColumnLines="true"
            :showRowLines="true"
            :wordWrapEnabled="false"
            :rtl-enabled="rtlEnabled"
          >
            <!-- <DxEditing :use-icons="true" :allow-updating="true" :allow-adding="false" :allow-deleting="false" mode="row" /> -->
            <DxScrolling mode="standard" :use-native="!rtlEnabled" />

            <DxPaging :page-size="10" />
            <DxPager
              :visible="true"
              :allowed-page-sizes="[10, 25, 50, 100, 'all']"
              :display-mode="'full'"
              :show-page-size-selector="true"
              :show-info="true"
              :show-navigation-buttons="true"
              :infoText="$t('common.page')"
            />

            <!-- <DxSelection mode="multiple"/> -->

            <!-- <DxFilterRow :visible="true" /> -->
            <!-- <DxFilterRow :visible="true" :apply-filter="currentFilter"/> -->

            <DxHeaderFilter :visible="true" />

            <!-- <DxSearchPanel :visible="true" placeholder="Search..." /> -->

            <!-- <DxGrouping :context-menu-enabled="true" /> -->
            <!-- <DxGroupPanel :visible="true" /> -->

            <DxColumn data-field="generate_time" :caption="$t('integrations.syncDate')" />

            <DxColumn data-field="sync_method" :caption="$t('integrations.syncMethod')" />

            <DxColumn
              :calculate-cell-value="getFullName"
              :allow-header-filtering="true"
              :allow-sorting="true"
              :caption="$t('common.by')"
            />

            <DxColumn :caption="$t('common.grid.action')" cell-template="action-cell" />

            <template #action-cell="{ data }">
              <b-button
                pill
                class="d-flex align-items-center px-3 top-page-btn"
                variant="primary"
                size="sm"
                @click="download(data.data)"
              >
              {{$t('common.download')}}
              </b-button>
            </template>
          </DxDataGrid>
          <!-- <table
              class="table table-striped table-borderless"
              style="margin-top: 40px"
            >
              <thead>
                <tr
                  style="
                    border-bottom: 20px solid white !important;
                    border-radius: 5px;
                  "
                >
                  <th scope="col " style="text-align: start; width: 10rem">
                    <sort-link name="id">Sync Date</sort-link>
                  </th>
                  <th scope="col" style="text-align: start; width: 10rem">
                    <sort-link name="name">Sync Method</sort-link>
                  </th>
                  <th scope="col" style="text-align: start; width: 10rem">
                    <sort-link name="hits">By Whom</sort-link>
                  </th>
                  <th scope="col" style="text-align: start; width: 10rem">
                    <sort-link name="hits">Actions</sort-link>
                  </th>
                </tr>
              </thead>
              <template>
                <tbody>
                  <tr
                    style="border-bottom: 20px solid white !important"
                    v-for="(log, index) in getSyncLogs"
                    :key="index"
                  >
                    <td style="">{{ log.generate_time }}</td>
                    <td>{{ log.sync_method }}</td>
                    <td>
                      {{ log.run_by.first_name }} {{ log.run_by.last_name }}
                    </td>
                    <td>
                      <b-button
                        pill
                        class="d-flex align-items-center px-3 top-page-btn"
                        variant="primary"
                        size="sm"
                        @click="download(log)"
                      >
                        Download
                      </b-button>
                    </td>
                  </tr>
                </tbody>
              </template>
            </table> -->
        </div>
      </div>
    </b-modal>

    <!-- delete integration warning  -->
    <b-modal
      :id="'removeIntegrationConfirmModal' + integrationData.id"
      class="popover-modal"
      hide-header
      hide-footer
      no-close-on-esc
      :ref="'removeIntegrationConfirmModal' + integrationData.id"
    >
      <VpConfirmModal
        :modalId="'removeIntegrationConfirmModal' + integrationData.id"
      >
        <template v-slot:title>
          <span>{{ $t("integrations.removeIntegration") }}</span>
        </template>

        <template v-slot:text1>
          <span
            >{{ $t("common.notes.areYouSureYouWant") }}
            <strong>“{{ $t("common.remove") }}”</strong>
            {{ $t("integrations.theIntegration") }}
            <strong>“{{ intgName }}”</strong
            >{{ $t("common.questionMark") }}</span
          >
        </template>

        <template v-slot:buttons>
          <VpButton
            :text="$t('common.cancel')"
            @click="
              $bvModal.hide(
                'removeIntegrationConfirmModal' + integrationData.id
              )
            "
          />
          <VpButton
            :text="$t('common.remove')"
            :isDanger="true"
            @click="deleteIng"
          />
        </template>
      </VpConfirmModal>
    </b-modal>

    <!-- <div class="custom-scroll"> -->
    <p
      v-if="
        integrationData &&
        integrationData.status == 'Draft' &&
        !integrationData.show_action
      "
    >
      -
    </p>

    <DxDropDownButton
      v-else
      :items="items"
      :drop-down-options="{ width: 141.41, maxHeight: 179 }"
      :scrollable="true"
      :text="$t('common.grid.selectActions')"
      class="selectActions"
      itemTemplate="actionsTemp"
    >
      <template #actionsTemp="{ data }">
        <div
          class="dropdown-wrapper"
          :class="{
            'hide-border':
              data.text ==
              items.filter((item) => item.visible)[
                items.filter((item) => item.visible).length - 1
              ].text,
          }"
          title=""
          v-b-modal="data.modalId ? data.modalId : null"
          @click="onActionSelect(data)"
        >
          <div
            class="dropdown-items"
            :class="{ 'red-remove': data.id == 'delete' }"
            title=""
          >
            {{ data.text }}
          </div>
          <!-- <hr
              v-if="data.text != items[items.length - 1].text"
              role="separator"
              aria-orientation="horizontal"
              class="dropdown-divider"
            /> -->
        </div>
      </template>
    </DxDropDownButton>
    <!-- </div> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import router from "../../router/index";

import DxDropDownButton from "devextreme-vue/drop-down-button";
import DxDataGrid, {
  // DxMasterDetail,
  DxColumn,
  //   DxFilterRow,
  DxHeaderFilter,
  // DxSearchPanel,
  DxPaging,
  DxPager,
  DxScrolling,
  //   DxGrouping,
  //   DxGroupPanel,
} from "devextreme-vue/data-grid";
export default {
  props: ["integrationData"],
  components: {
    DxDropDownButton,
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxPaging,
    DxPager,
    DxScrolling
  },
  data() {
    return {
      rtlEnabled: false,
      items: [],
      getSyncLogs: [],
      intgName: "",
      intgId: "",
    };
  },
  beforeMount() {
    if (this.getLanguage === "ar") {
      this.rtlEnabled = true;
    }
    this.items = [];
    this.items.push(
      {
        text: this.$t("common.view"),
        id: "view",
        visible:
          this.integrationData.status != "Draft" &&
          this.integrationData.status != "Pending" &&
          this.integrationData.status != "Ready",
      },
      {
        text: this.$t("integrations.forceSync"),
        id: "forceSync",
        visible:
          this.integrationData.status != "Expired" &&
          this.integrationData.status != "Draft" &&
          this.integrationData.status != "Authentication Failed" &&
          this.integrationData.status != "Authentication failed" &&
          this.integrationData.status != "Invalid" &&
          this.integrationData.status != "Pending" &&
          this.integrationData.status != "Ready",
      },
      {
        text: this.$t("integrations.seeErrors"),
        id: "error",
        visible:
          this.integrationData.status != "Expired" &&
          this.integrationData.status != "Draft" &&
          this.integrationData.showErrors,
      },
      {
        text: this.$t("integrations.seeDuplicates"),
        id: "duplicate",
        visible:
          this.integrationData.status != "Expired" &&
          this.integrationData.status != "Draft" &&
          this.integrationData.status != "Pending" &&
          this.integrationData.status != "Ready" &&
          this.integrationData.showDuplicates,
      },
      {
        text: this.$t("integrations.writeDataBack"),
        id: "writeBack",
        visible:
          this.integrationData.status != "Expired" &&
          this.integrationData.status != "Draft" &&
          this.integrationData.showWriteBack,
      },
      {
        text: this.$t("integrations.syncLogs"),
        id: "syncLogs",
        visible:
          this.integrationData.status != "Draft" &&
          this.integrationData.status != "Pending" &&
          this.integrationData.status != "Ready",
      },
      {
        text: this.$t("common.edit"),
        id: "edit",
        visible:
          this.integrationData.status != "Draft" &&
          this.integrationData.status.toLowerCase() !=
            "authentication failed" &&
          this.integrationData.status != "Invalid" &&
          this.integrationData.status != "Pending" &&
          this.integrationData.status != "Ready",
      },
      {
        text: this.$t("common.continue"),
        id: "continue",
        visible: this.integrationData.status == "Draft",
      },
      {
        text: this.$t("integrations.start"),
        id: "startPendingIntegration",
        modalId: "addIntegration",
        visible: this.integrationData.status == "Pending",
      },
      {
        text: this.$t("integrations.attendanceCodes"),
        id: "attendanceCodes",
        visible:
          this.integrationData.status != "Draft" &&
          this.integrationData.integrationType == "wonde",
      },
      {
        text: this.$t("common.remove"),
        id: "delete",
        visible: this.integrationData.show_remove ? true : false,
      }
    );
  },

  computed: {
    ...mapGetters("i18N", ["getLanguage"]),
    ...mapGetters("integration", [
      "getDirectoryList",
      "getIntgData",
      "getIsExtraScenario",
    ]),
  },

  methods: {
    ...mapActions("modal", ["setData"]),
    ...mapActions("integration", [
      "deleteIntegration",
      "awaitIntegrationWithMapping",
      "editIntegration",
      "startAutoSync",
      "fetchUsersJobStatus",
      "checkDuplicate",
      "setIsExtraScenario",
      "getIntegration",
      "createIntegration",
      "createConfigData",
      "getSyncLogsList",
      "fetchIntegrationScans",
    ]),

    getFullName(rowData) {
      return rowData.sync_method == "Manual" && rowData.run_by
        ? rowData.run_by.email == "lt_techteam@visipoint.com"
          ? "Admin - CS"
          : rowData.run_by.first_name + " " + rowData.run_by.last_name
        : rowData.sync_method == "Automatic"
        ? "System"
        : "";
    },

    onActionSelect(data) {
      switch (data.id) {
        case "view":
          this.viewPage(
            this.integrationData.id,
            this.integrationData.integrationName
          );
          break;
        case "forceSync":
          this.startAutoSync({
            id: this.integrationData.id,
            name: this.integrationData.integrationName,
            redirectToView: true,
          });
          break;
        case "error":
          this.redirectUser(
            "error",
            this.integrationData.id,
            this.integrationData.integrationName
          );
          break;
        case "duplicate":
          this.redirectUser(
            "duplicate",
            this.integrationData.id,
            this.integrationData.integrationName
          );
          break;
        case "writeBack":
          this.redirectUser(
            "writeBack",
            this.integrationData.id,
            this.integrationData.integrationName
          );
          break;
        case "syncLogs":
          this.openSyncLogs(this.integrationData);
          break;
        case "edit":
          this.editIntg(this.integrationData.id, this.integrationData);
          break;
        case "continue":
          this.onContinue(this.integrationData.id, this.integrationData);
          break;
        case "startPendingIntegration":
          this.startPendingIntegrationAction(this.integrationData);
          break;
        case "startReadyIntegration":
          this.startReadyIntegrationAction(this.integrationData);
          break;
        case "attendanceCodes":
          this.redirectUserToAttendanceCodes(
            this.integrationData.id,
            this.integrationData.integrationName
          );
          break;
        case "delete":
          this.openRemoveWarning(this.integrationData);
          break;
        default:
          break;
      }
    },

    async viewPage(id, name) {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";
      console.log("rer", name, id);
      // this.checkDuplicate({ id: this.getIntegId, fromView: true }).then(res => {
      //   this.fetchUsersJobStatus
      // });
      await this.$store.dispatch("integration/setFromView", true);
      router.push("/view-integration/" + id + "/" + name);
      // this.awaitIntegrationWithMapping({ id, name, redirect: true });
    },

    async redirectUserToAttendanceCodes(id, name) {
      await this.$store.commit("integration/setIntegId", id);
      await this.$store.dispatch("integration/setFromView", true);
      router.push(`/attendance-codes/${id}/${name}`);
      return;
    },

    async redirectUser(data, id, name) {
      console.log("id", id);
      await this.$store.commit("integration/setIntegId", id);
      if (data == "writeBack") {
        // await this.fetchIntegrationScans(id);
        router.push(`/write-back?integName=${name}`);
        return;
      }
      await this.$store.dispatch("integration/setFromView", true);
      await this.$store.commit("integration/setIntgDataMapping", {
        name: name,
      });
      if (data == "duplicate") {
        await this.$store.dispatch("integration/getIntegration", { id });
        this.checkDuplicate({ id: id, redirectToDuplicate: true });
      } else router.push("/integration-" + data);
    },

    async openSyncLogs(data) {
      try {
        this.getSyncLogsList(data.id).then((response) => {
          console.log("resp", data.id, response);
          this.getSyncLogs = JSON.parse(JSON.stringify(response));
          console.log("getSyncLogs", this.getSyncLogs);
          this.getSyncLogs.map(
            (item) =>
              (item.generate_time = item.generate_time
              ? (
                this.getLanguage === "ar" ? moment(new Date(item.generate_time + " UTC")).locale('en') // Ensures numbers remain in English
            .format("DD/MM/YYYY - h:mm:ss") + 
            (moment(new Date(item.generate_time + " UTC")).format("A") === "AM" ? " ص" : " م")
            : moment(new Date(item.generate_time + " UTC")).format("DD/MM/YYYY - h:mm:ss A"))
              : "")
          );
          this.$bvModal.show("syncLogsModal" + data.id);
        });
      } catch (error) {
        console.log(error);
      }
    },

    async editIntg(id, data) {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";

      // setTimeout(function () {
      //   document.getElementById("preloader").style.display = "none";
      //   document.getElementById("status").style.display = "none";
      // }, 1000);
      this.setIsExtraScenario(false);
      const modalData = this.getDirectoryList.find(
        (directory) => directory.code === data.integrationType
      );
      await this.setData(modalData);
      this.editIntegration(id);
    },

    async onContinue(id, data) {
      const modalData = this.getDirectoryList.find(
        (directory) => directory.code === data.integrationType
      );
      await this.setData(modalData);
      await this.getIntegration({
        id,
        fromAllTable: true,
        continue: true,
      });
      this.fetchUsersJobStatus({
        id: id,
        saveAndSync: false,
        continue: true,
      });
    },

    async startPendingIntegrationAction(data) {
      const modalData = this.getDirectoryList.find(
        (directory) => directory.code === data.integrationType
      );

      await this.$store.commit("integration/setIntegId", data.id);
      this.setIsExtraScenario(true);

      await this.setData(modalData);
    },

    async startReadyIntegrationAction(data) {
      const obj = {};
      this.getIntegration({ id: data.id }).then((res) => {
        const integrationConfigs = res.configs;
        integrationConfigs.forEach((config) => {
          obj[config.key_code] = config.value;
        });
        obj.dir_int_id = data.id;
        this.createIntegration({
          directory_type: data.integrationType,
          obj,
          isExtraScenario: this.getIsExtraScenario,
        });
        const configData = integrationConfigs.map((item) => {
          return {
            key_id: item.key_id,
            value: item.value,
            key_code: item.key_code,
          };
        });
        // console.log('configData',configData);
        this.createConfigData(configData);
      });
      const modalData = this.getDirectoryList.find(
        (directory) => directory.code === data.integrationType
      );
      await this.setData(modalData);
      this.setIsExtraScenario(true);
    },

    openRemoveWarning(data) {
      this.intgName = data.integrationName;
      this.intgId = data.id;
      this.$bvModal.show("removeIntegrationConfirmModal" + data.id);
    },

    deleteIng() {
      this.deleteIntegration(this.intgId);
      this.$bvModal.hide("removeIntegrationConfirmModal" + this.intgId);
    },

    download(log) {
      window.open(
        `${process.env.VUE_APP_INTEGRATION_URL}/${log.file_name}`,
        "_blank"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
h5.modal-title {
  width: 100%;
  font-weight: 700 !important;
  font-size: 16px !important;
  line-height: 20px !important;
  text-align: center !important;
  letter-spacing: 0.25px !important;
  color: #000000 !important;
}
</style>
<style lang="scss">
.hide-border {
  border: none !important;
}
.dropdown-wrapper {
  padding: 0;
  border-bottom: 1px solid #e9e9e9;
  .dropdown-items {
    font-weight: 400;
    font-size: 16px !important;
    text-align: center;
    line-height: 19px !important;
    color: #787878;
    margin: 6px auto 12px auto !important;
    white-space: break-spaces;
  }

  .red-remove {
    color: #f46a6a !important;
  }
}

.dx-scrollable-scroll.dx-state-invisible,
.dx-scrollable-scroll-content {
  background: #666666 !important;
  border-radius: 8.5px !important;
}
.dx-scrollable-scrollbar.dx-widget.dx-scrollbar-vertical.dx-scrollbar-hoverable {
  background: #ededed !important;
  border-radius: 8.5px !important;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3) !important;
}
div[id*="syncLogsModal"] {
  div[id*="___BV_modal_content_"] {
    h5.modal-title {
      margin-bottom: 41px;
    }

    .header-close-style {
      margin-bottom: 41px;
    }
  }
}
</style>
